import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

@Entity()
export class BasePartnerEditMediaExtension extends BaseEditExtension {
  static override _class = 'BasePartnerEditMediaExtension';
}
